module.exports = __webpack_public_path__ + "profile-3-d-9hC.png";